import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {EndorseFinalRoutingModule} from "./endorse-final-routing.module";
import {GlobalModule} from "../global/global.module";
import {EndorseFinalComponent} from "./endorse-final.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EndorseFinalRoutingModule,
    GlobalModule,
  ],
  declarations: [
    EndorseFinalComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EndorseFinalModule {
}
